export const PlayIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Play",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...rest}>
      <title>{title}</title>
      <path
        d="M20 12L8 18.9282L8 5.0718L20 12Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
};
